import { Button } from "@somethings-ui/web/src/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Camera, Mic } from "lucide-react";
import { ByType } from "react-record-webcam";

export const RecordingStarterModal = ({
  videoDeviceId,
  setVideoDeviceId,
  audioDeviceId,
  setAudioDeviceId,
  handleStartRecording,
  devicesByType,
  canUpdateMentorships,
}: {
  videoDeviceId: string;
  setVideoDeviceId: (deviceId: string) => void;
  audioDeviceId: string;
  setAudioDeviceId: (deviceId: string) => void;
  handleStartRecording: () => void;
  devicesByType: ByType | undefined;
  canUpdateMentorships: boolean;
}) => {
  if (!canUpdateMentorships) {
    return (
      <div className="space-y-2">
        <h2 className="text-lg font-semibold">Recording unavailable</h2>
        <p className="text-sm text-muted-foreground">
          You do not have permission to create mentor monthly updates.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-lg font-semibold">Recording Settings</h2>
      </div>
      <div className="space-y-4">
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <Camera className="h-5 w-5 text-muted-foreground" />
            <Select value={videoDeviceId} onValueChange={setVideoDeviceId}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select video device" />
              </SelectTrigger>
              <SelectContent>
                {devicesByType?.video?.map((device) => (
                  <SelectItem key={device.deviceId} value={device.deviceId}>
                    {device.label || "Default Camera"}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <Mic className="h-5 w-5 text-muted-foreground" />
            <Select value={audioDeviceId} onValueChange={setAudioDeviceId}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select audio device" />
              </SelectTrigger>
              <SelectContent>
                {devicesByType?.audio?.map((device) => (
                  <SelectItem key={device.deviceId} value={device.deviceId}>
                    {device.label || "Default Microphone"}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <Button
          className="w-full"
          onClick={handleStartRecording}
          disabled={!videoDeviceId || !audioDeviceId}
        >
          Start Recording
        </Button>
      </div>
    </div>
  );
};
